import { X } from 'lucide-react';
import i18n from '@/settings/i18n';
import { ConditionModalHeaderProps } from './types';

const t = i18n.init('product');

const Header = ({ setShowModal }: ConditionModalHeaderProps) => (
  <div className="sticky top-0 z-[70] flex items-center justify-between bg-white p-4 text-sm shadow">
    <div>
      <h1 className="w-full text-base font-extrabold leading-5">
        {t`Condition Detail`}
      </h1>
    </div>
    <button
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-700 text-white  transition duration-150 ease-in-out hover:scale-110 focus:outline-none"
      onClick={() => setShowModal(false)}
    >
      <X className="h-4 w-4" />
    </button>
  </div>
);

export default Header;
